import React, { Component } from 'react';
import FolderMgt from '../component/folderMgt'
import Start from '../component/start'
import TransitionGroup from 'react-transition-group/TransitionGroup'

import { BrowserRouter as Router, Route, Switch} from "react-router-dom";

const FtpRouter = function ({ basename = '/acctMgt'}) {
    return (
        <Router basename='custom/ftpMgt' >
        <div>
   
        <div >

        <Switch >
          <Route exact path="/" component={Start} />
          <Route exact path="/start" component={FolderMgt} />
          
        
        
         </Switch>
        
        
    

        </div>

        </div>
    
      </Router>

    )
  }
  
  export default FtpRouter